import React from "react";
import { fetchMedia } from "../../api/media";
import { useApi } from "../../hooks/useApi";
import { Spinner } from "retro-react";
import { LoadingBox } from "../../components/LoadingBox";

export const AboutImage = ({ 
    aboutImageID
    }) => {
    const {output: aboutImageObject, loading: aboutLoading, error: aboutError} = useApi(fetchMedia, aboutImageID); //TODO ok found the bug you j have to change the destruction of aboutImageID here
    const aboutImageURL = aboutImageObject?.source_url;

    if (aboutLoading){
        return(
            <div className="image-spinner">
                <LoadingBox/>
            </div>
        );

    }

    return(
        <img className="profile-photo" src={aboutImageURL} alt="Nick Bendzsa"/> 
    );
}